module.exports = __webpack_public_path__ + "6b722bce7eaad47eb3d8c7632fdcc3bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/footer/image-3.jpg
// module id = ./assets/images/footer/image-3.jpg
// module chunks = 0